import {
  EnvironmentProviders,
  inject,
  LOCALE_ID,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, switchMap, take } from 'rxjs';
import { PortalContextService } from '../modules/portal-context/portal-context.service';
import { NavigationsService } from '../navigations/services/navigations.service';
import { DEFAULT_LANGUAGE, PortalLanguageService } from './portal-language.service';

/**
 * Starts the portal in the language of {@link PortalLanguageService} (`LOCALE_ID`, translations and through
 * `LOCALE_ID` the API language header), and switches to the relation's language once a portal user's context is known.
 */
export function provideLanguage(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LOCALE_ID, useFactory: () => inject(PortalLanguageService).current },
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.setDefaultLang(DEFAULT_LANGUAGE);
      return translate.use(inject(PortalLanguageService).current);
    }),
    provideAppInitializer(() => {
      const language = inject(PortalLanguageService);
      const portalContext = inject(PortalContextService);
      // Not awaited: the context needs a signed-in portal user, and the app must start before that.
      inject(NavigationsService)
        .isPortalUser()
        .pipe(
          filter(Boolean),
          take(1),
          switchMap(() => portalContext.get())
        )
        .subscribe({
          next: (context) => language.applyRelationLanguage(context?.languageAlpha2Code),
          error: () => undefined,
        });
    }),
  ]);
}
